import PropTypes from "prop-types";
import React from "react";
import { Image, Label, Modal } from "semantic-ui-react";
import { FormattedMessage } from "react-intl";
import FormatCurrency from "shared/components/currency/FormatCurrency";
import ProductInfoItem from "../../../builder_portal/components/product/ProductInfoItem";

export default class OptionDetailsModal extends React.PureComponent {
  static propTypes = {
    option: PropTypes.object.isRequired,
    subLineItem: PropTypes.object,
    renderTags: PropTypes.bool
  };

  render() {
    const {
      renderTags = true,
      option,
      option: {
        description,
        hasCart,
        isActualSelection,
        isDefault,
        isOnRequest,
        name,
        priceStrategy,
        productLines,
        status,
        thumbUrl,
        total
      },
      subLineItem: {
        quantity,
        status: { selectable }
      },
      ...passThroughProps
    } = this.props;

    const tags = (productLines || []).map((tag, idx) => {
      return (
        <Label
          key={idx}
          basic={!tag.active}
          color={tag.active ? "grey" : null}
          content={tag.name}
        />
      );
    });

    const showPriceTag = isActualSelection || selectable;

    const { portal } = window.initialProps;

    return (
      <Modal
        {...passThroughProps}
        closeIcon
        data-component="optionDetailsModal"
        data-portal={portal}
      >
        <Modal.Header>{name}</Modal.Header>
        <Modal.Content image>
          <Image wrapped src={thumbUrl} />
          <Modal.Description>
            {isDefault && (
              <Label basic data-attr="isDefault">
                <span>Standardauswahl</span>
              </Label>
            )}
            {hasCart && (
              <Label
                data-attr="status"
                style={status.color ? { backgroundColor: status.color } : null}
                content={status.label}
              />
            )}
            <ProductInfoItem product={option} mode="bp_card" />
            <p className="preWrap">{description}</p>
            {!!tags.length && renderTags && (
              <p style={{ marginTop: "10px" }}>{tags}</p>
            )}
            <p data-attr={`quantity-${priceStrategy}`}>
              {priceStrategy !== "flat" && (
                <FormattedMessage
                  id={`roomBook.priceStrategyLongValue.${priceStrategy}`}
                  values={{ quantity }}
                />
              )}
            </p>

            {showPriceTag && (
              <p data-attr="total">
                {isOnRequest ? (
                  <FormattedMessage id="product_group.price_strategies.on_request" />
                ) : (
                  <FormatCurrency amount={total} />
                )}
              </p>
            )}
          </Modal.Description>
        </Modal.Content>
      </Modal>
    );
  }
}
